if (!customElements.get('kerst-sticky-cart')) {
  customElements.define('kerst-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.button = this.querySelector('.ks-cart__button');
      this.label = this.querySelector('.ks-cart__label');
      this.error = this.querySelector('.ks-cart__error');
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
      };
      const signal = this.abort.signal;
      this.button.addEventListener('click', () => {
        this.bindSource();
        if (!this.source || this.source.disabled || this.source.getAttribute('aria-disabled') === 'true') return;
        this.source.click();
        this.sync();
      }, { signal });
      this.querySelector('.ks-cart__product').addEventListener('click', () => {
        if (!this.root) return;
        this.root.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        this.source?.focus({ preventScroll: true });
      }, { signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      document.addEventListener('change', this.schedule, { signal });
      document.addEventListener('input', this.schedule, { signal });
      document.addEventListener('shopify:section:load', this.schedule, { signal });
      this.bodyObserver = new MutationObserver(this.schedule);
      this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
      this.interval = setInterval(this.schedule, 700);
      this.sync();
    }
    bindSource() {
      const source = document.querySelector('#MainContent [data-st-atc], #MainContent product-form .product-form__submit');
      if (source === this.source) return;
      this.sourceObserver?.disconnect();
      this.source = source;
      this.root = source?.closest('[class*="st_product-info--"], product-info, .product__info-container');
      if (!source || !this.root) return;
      this.sourceObserver = new MutationObserver(this.schedule);
      this.sourceObserver.observe(this.root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'value'] });
      const style = getComputedStyle(source);
      this.style.setProperty('--ks-button', style.backgroundColor);
      this.style.setProperty('--ks-button-text', style.color);
      this.style.fontFamily = style.fontFamily;
      const title = this.root.querySelector('.st_pi-title, .product__title');
      if (title?.textContent.trim()) this.querySelector('.ks-cart__title').textContent = title.textContent.trim();
    }
    sync() {
      this.bindSource();
      if (!this.source || !this.root) { this.hidden = true; return; }
      this.hidden = false;
      const loading = this.source.classList.contains('st_pi-atc--loading') || this.source.classList.contains('loading');
      const success = this.source.classList.contains('st_pi-atc--success');
      this.button.disabled = this.source.disabled || this.source.getAttribute('aria-disabled') === 'true' || loading;
      this.button.classList.toggle('is-loading', loading);
      this.button.classList.toggle('is-success', success);
      this.button.setAttribute('aria-busy', String(loading));
      const text = (this.source.querySelector('[data-st-atc-label]') || this.source).textContent.trim();
      if (this.label.textContent !== text) this.label.textContent = text;
      const options = Array.from(this.root.querySelectorAll('.st_pi-option input:checked, .st_pi-option select')).map(el => el.value).filter(v => v && v !== 'Default Title').join(' / ');
      const optionsNode = this.querySelector('.ks-cart__options');
      optionsNode.textContent = options;
      optionsNode.hidden = !options;
      const errorNode = this.root.querySelector('[data-st-error], .product-form__error-message');
      const errorText = errorNode && errorNode.getClientRects().length ? errorNode.textContent.trim() : '';
      if (this.error.textContent !== errorText) this.error.textContent = errorText;
      this.error.hidden = !errorText;
      const rect = this.source.getBoundingClientRect();
      const locked = [document.body, document.documentElement].some(el => ['hidden', 'clip'].includes(getComputedStyle(el).overflowY));
      const overlay = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], cart-drawer.active, cart-notification.active')).some(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      const visible = rect.bottom < 0 && rect.width > 0 && !locked && !overlay;
      this.classList.toggle('is-visible', visible);
      this.inert = !visible;
      this.setAttribute('aria-hidden', String(!visible));
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.sourceObserver?.disconnect();
      this.bodyObserver?.disconnect();
      clearInterval(this.interval);
      cancelAnimationFrame(this.frame);
    }
  });
}
